import { render } from "./Modules.vue?vue&type=template&id=0664a91f&scoped=true&ts=true"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"

import "./Modules.vue?vue&type=style&index=0&id=0664a91f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0664a91f"]])

export default __exports__